module.exports = __webpack_public_path__ + "media/images/Lock_Shadow_Gold_Unlocked_38@2x-ef87e779bbed0d25f4a36af1d5a98741.png";